<template>
    <div class="pa-2">
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'roles/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="getAll()">
			<!-- {{ $T('.delete-message') }} -->
            هل أنت متأكد من أنك تريد حذف هذا الدور ؟ّ
		</v-delete-dialog>

        <!-- dialog -->
        <v-dialog
			v-model="dialog"
			max-width="850px"
			transition="dialog-transition"
        >
			<v-card>
				<v-card-title primary-title>
					إضافة دور
					<v-spacer></v-spacer>
					<v-btn
						@click="dialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="6">
							<v-text-field
								v-model="name"
								outlined
								dense
								label="الاسم"
								hide-details></v-text-field>
						</v-col>

                        <v-col cols="6">
							<v-autocomplete
								v-model="parentId"
                                :items="roles"
                                item-text="name"
                                item-value="id"
								outlined
								dense
								label="الدور الأب"
								hide-details />
						</v-col>

                        <v-col cols="12">
							<v-checkbox
								v-model="viewAllEmployee"   
                                label="عرض على كل الموظفين"
                                hide-details
                            />
						</v-col>

                        <v-col cols="12">
                            <div>
                                <h3 class="primary--text mb-2"> الصلاحيات </h3>
                                <bee-handy-table
                                    :headers="headersPer"
                                    :items="myItems"
                                    dense
                                    zebra
                                    :height="$vuetify.breakpoint.height - 160"
                                    :items-per-page="-1"
                                    fixed-header
                                    hide-default-footer
                                    :loading="loading"
                                >
                                    <template v-slot:item.rolePermissions="{ item }">
                                        <v-radio-group
                                            v-model="item.rolePermissions"
                                            row
                                            hide-details
                                            class="mt-0"
                                            :disabled="Boolean($route.query.preview)"
                                        >
                                            <v-radio
                                                label="Read"
                                                :value="1"
                                            ></v-radio>
                                            <v-radio
                                                label="Action"
                                                :value="2"
                                            ></v-radio>
                                            <v-radio
                                                label="Create"
                                                :value="3"
                                            ></v-radio>
                                            <v-radio
                                                label="Modify"
                                                :value="4"
                                            ></v-radio>
                                            <v-radio
                                                label="Nothing"
                                                :value="0"
                                            ></v-radio>
                                        </v-radio-group>
                                    </template>
                                </bee-handy-table>
                            </div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="loadingAdding || !name"
						:loading="loadingAdding"
						@click="createOrEdit">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-row>
            <v-spacer />
            <v-col cols="auto">
				<v-btn
					@click="dialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
        </v-row>
        <bee-handy-table 
            :headers="headers"
            :items="roles"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
            class="mt-2"
            :loading="loading"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <tooltip :text="$T('tooltips.edit')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; dialog = true"
                            >
                            <v-icon
                                size="20"
                                color="edit-color">
                                $edit
                            </v-icon>
                        </v-btn>
                    </tooltip>

                    <tooltip :text="$T('tooltips.delete')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; deleteDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="alert-color  ">
                                $delete
                            </v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    watch: {
        dialog(val) {
            if(val && this.itemId !== null) {
                this.name = this.roles.find(c => c.id === this.itemId)?.name
                this.parentId = this.roles.find(c => c.id === this.itemId)?.name
                this.viewAllEmployee = this.roles.find(c => c.id === this.itemId)?.viewAllEmployee
                this.myItems = this.roles.find(c => c.id === this.itemId)?.permissions.length ? this.roles.find(c => c.id === this.itemId)?.permissions : this.myItems.map(c => ({ permissionsNames: c.permissionsNames , rolePermissions: 0, explain: c.explain }))
            } else {
                this.name = null 
                this.itemId = null
                this.myItems = this.myItems.map(c => ({ permissionsNames: c.permissionsNames , rolePermissions: 0, explain: c.explain }))
            }
        }
    },
    data () {
        return {
            loading: false,
            loadingAdding: false,
            itemId: null,
            deleteDialog: false,
            headers: [
                {
                    text: 'الدور',
                    name: 'name',
                    value: 'name'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ],
            dialog: false,
            name: null,
            myItems: [
                {
                    permissionsNames: 0,
                    rolePermissions: 0,
                    explain: 'صلاحيات على الأقسام'
                },
                {
                    permissionsNames: 1,
                    rolePermissions: 0,
                    explain: 'صلاحية الاطلاع على الموظفين'
                },
                {
                    permissionsNames: 2,
                    rolePermissions: 0,
                    explain: 'صلاحيات إنشاء موظف جديد'
                },
                {
                    permissionsNames: 3,
                    rolePermissions: 0,
                    explain: 'عمل شخصي'
                },
                {
                    permissionsNames: 4,
                    rolePermissions: 0,
                    explain: 'صلاحيات على تعديلات الدوام',
                },
                {
                    permissionsNames: 5,
                    rolePermissions: 0,
                    explain: 'صلاحيات على الإجازات',
                },
                {
                    permissionsNames: 6,
                    rolePermissions: 0,
                    explain: 'صلاحيات على الأذونات'
                },
                {
                    permissionsNames: 7,
                    rolePermissions: 0,
                    explain: 'صلاحيات على المهام',
                },
                {
                    permissionsNames: 8,
                    rolePermissions: 0,
                    explain: 'صلاحيات على استيراد بصمة',
                },
                {
                    permissionsNames: 9,
                    rolePermissions: 0,
                    explain: 'صلاحيات على الرواتب',
                },
                {
                    permissionsNames: 10,
                    rolePermissions: 0,
                    explain: 'صلاحيات متعلقة بالعقوبات و المكافأت'
                },
                {
                    permissionsNames: 11,
                    rolePermissions: 0,
                    explain: 'صلاحيات على التدريب',
                },
                {
                    permissionsNames: 12,
                    rolePermissions: 0,
                    explain: 'صلاحيات على التذكيرات',
                },
                {
                    permissionsNames: 13,
                    rolePermissions: 0,
                    explain: 'صلاحيات على الإعدادات',
                },
                {
                    permissionsNames: 14,
                    rolePermissions: 0,
                    explain: 'صلاحيات على التكليف',
                }
            ],

            viewAllEmployee: false,
            parentId: null,
            permissionsWithName: [
                {
                    id: 0,
                    permissionsNames: 'Sections'
                },
                {
                    id: 1,
                    permissionsNames: 'Employee'
                },
                {
                    id: 2,
                    permissionsNames: 'New employee'
                },
                {
                    id: 3,
                    permissionsNames: 'Personal action'
                },
                {
                    id: 4,
                    permissionsNames: 'Attend',
                },
                {
                    id: 5,
                    permissionsNames: 'Leaves',
                },
                {
                    id: 6,
                    permissionsNames: 'Permissions'
                },
                {
                    id: 7,
                    permissionsNames: 'Tasks',
                },
                {
                    id: 8,
                    permissionsNames: 'Import fingerPrint',
                },
                {
                    id: 9,
                    permissionsNames: 'Salaries',
                },
                {
                    id: 10,
                    permissionsNames: 'Punishments and rewards'
                },
                {
                    id: 11,
                    permissionsNames: 'Training',
                },
                {
                    id: 12,
                    permissionsNames: 'Reminders',
                },
                {
                    id: 13,
                    permissionsNames: 'Settings',
                },
                {
                    id: 14,
                    permissionsNames: 'Assignment',
                }

            ]
        }
    },

    computed: {
        ...mapState({
            roles: state => state.roles.roles
        }),

        headersPer() {
            return [
                {
                    text: 'Name',
                    name: 'Name',
                    value: 'permissionsNames',
                    noNotAvailableText: true,
                    setValueExpr: val => this.permissionsWithName.find(c => c.id === +val)?.permissionsNames
                },
                {
                    text: 'Permissions',
                    name: 'rolePermissions',
                    value: 'rolePermissions'
                },
                {
                    text: 'Explanation',
                    name: 'explain',
                    value: 'explain',
                    width: '30%'
                }
            ]
        }
    },

    methods: {
        createOrEdit () {
            this.loadingAdding = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`roles/${actionName}`, { 
                name: this.name,  id: this.itemId ? this.itemId : null,
                parentRoleId: this.parentRoleId,
                viewAllEmployee: this.viewAllEmployee, 
                permissions: this.myItems.map(c => ({ permissionsNames: c.permissionsNames, rolePermissions: c.rolePermissions }))
            }).then(() => {
                this.getAll()
            }).finally(() => {
                this.loadingAdding = false
                this.loading = false
                this.dialog = false
            })
        },

        getAll() {
            this.loading = true
            return this.$store.dispatch('roles/fetchAll').then((data) => {
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        this.loading = true
        this.$store.dispatch('roles/fetchAll').then(() => {
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>
